type First90DaysPlanActionsProps = {
  handleOpenPlan: () => void
  handleClosePlan: () => void
}

export const useFirst90DaysPlanActions = (): First90DaysPlanActionsProps => {
  const handleOpenPlan = () => {
    // TODO: Implement open plan
  }

  const handleClosePlan = () => {
    // TODO: Implement close plan
  }

  return {
    handleOpenPlan,
    handleClosePlan,
  }
}
